/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If this component does not
 * do what you need it to, please reach out to a frontend
 * engineer before creating a new component or making
 * unapproved changes to this file.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import TableHead from './head';
import TableHeading from './heading';
import TableBody from './body';
import TableRow from './row';
import TableData from './data';
import Pagination from './pagination';
import styles from './table.scss';

export { TableHeadPropTypes } from './head';
export { TableHeadingPropTypes } from './heading';
export { TableBodyPropTypes } from './body';
export { TableRowPropTypes } from './row';
export { TableDataPropTypes } from './data';

export const TableContext = React.createContext<string | null>(null);
export const SelectedContext = React.createContext<Function | null>(null);
export const CurrentPageContext = React.createContext<number | null>(null);

export type TablePropTypes = React.BaseHTMLAttributes<HTMLTableElement> & {
  currentPage: number,
  showPagination?: boolean,
  numPages?: number,
  allowSelect?: boolean,
  isLoading?: boolean,
  activeKey?: string | null,
  sidebar?: (data: Object) => JSX.Element,
  onPageChange?: (page: number) => void,
  onSelectRow?: (key: string | null) => void,
};

function Table({
  currentPage = 1,
  numPages = 1,
  className = '',
  allowSelect = true,
  isLoading = false,
  activeKey = null,
  showPagination = true,
  sidebar,
  onPageChange,
  onSelectRow,
  children,
  ...props
}: TablePropTypes) {

  const handleSelect = React.useCallback((newKey) => {
    if (onSelectRow) {
      onSelectRow(newKey);
    }
  }, [onSelectRow]);

  const handlePageChange = React.useCallback((newPage) => {
    if (onPageChange) {
      onPageChange(newPage);
    }
  }, [onPageChange]);

  return (
    <TableContext.Provider value={activeKey}>
      <SelectedContext.Provider value={handleSelect}>
        <CurrentPageContext.Provider value={currentPage}>
          <table
            data-qa-ref="table"
            className={classnames(styles.table, className, {
              [styles.allowSelect]: allowSelect,
            })}
            {...props}
          >
            {children}
          </table>
          {!!onPageChange && numPages > 0 && showPagination && (
            <Pagination
              currentPage={currentPage}
              numPages={numPages}
              isLoading={isLoading}
              onPageChange={handlePageChange} />
          )}
        </CurrentPageContext.Provider>
      </SelectedContext.Provider>
    </TableContext.Provider>
  );
}

Table.Head = TableHead;
Table.Heading = TableHeading;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Data = TableData;

export default Table;
